import { FiSun } from "react-icons/fi";
import { BsMoonStars } from "react-icons/bs";
import useTheme from "src/hooks/useTheme";

const Theme = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <>
      <div className="toggle-theme-container">       
        <button onClick={toggleTheme}>
          {theme === "light" &&<BsMoonStars
            style={{
              color: "black",
              fontSize: "1.5em",
              stroke: "currentcolor",
            }}
          />}
          {theme === "dark" &&<FiSun
            style={{
              color: "white",
              fontSize: "1.5em",
              stroke: "currentcolor",
            }}
          />}
        </button>
      </div>
    </>
  );
};

export default Theme;
